import { useCallback, useState } from 'react';
import { useMedplum } from '@medplum/react';
import { CodeableConcept, Patient, Specimen } from '@medplum/fhirtypes';

export interface UseSpecimenActionsReturn {
  loadSpecimens: (
    patient: Patient | undefined,
    specimenType?: CodeableConcept
  ) => Promise<Specimen[]>;
  loading: boolean;
}

export function useSpecimenActions(): UseSpecimenActionsReturn {
  const medplum = useMedplum();
  const [loading, setLoading] = useState(false);

  const loadSpecimens = useCallback(
    async (
      patient: Patient | undefined,
      specimenType?: CodeableConcept
    ): Promise<Specimen[]> => {
      if (!patient?.id) {
        return [];
      }

      setLoading(true);

      try {
        let specimens: Specimen[] = [];

        if (specimenType?.coding?.[0]?.code) {
          // Search specimens with type filter
          specimens = await medplum.searchResources('Specimen', {
            subject: `Patient/${patient.id}`,
            _sort: '-_lastUpdated',
            _count: '50',
            type: specimenType.coding[0].code,
          });
        } else {
          // No type filter - show all specimens for this patient
          specimens = await medplum.searchResources('Specimen', {
            subject: `Patient/${patient.id}`,
            _sort: '-_lastUpdated',
            _count: '50',
          });
        }

        return specimens;
      } catch (error) {
        console.error('Failed to load specimens:', error);
        return [];
      } finally {
        setLoading(false);
      }
    },
    [medplum]
  );

  return { loadSpecimens, loading };
}
